
document.addEventListener("DOMContentLoaded", function(){


  var playButton=document.querySelectorAll(".test-play__button");
  var pauseBtn=document.querySelectorAll(".test__pause--btn")
 
  playButton.forEach(function(ele){
  
  
  
  ele.addEventListener("click", function(){
  
    var parentDiv=ele.closest(".video__container--testimonial")
    var innerVideo=parentDiv.querySelector(".test__content--video video");
    var videoPoster=parentDiv.querySelector('.test-image__poster')
    innerVideo.play();
    innerVideo.controls = false;
    ele.style.display="none";
    var pauseBtn=parentDiv.querySelector(".test__pause--btn");
    pauseBtn.style.display="block";
    videoPoster.style.display="none";
  })
})

  pauseBtn.forEach(function(ele){
    

    ele.addEventListener("click",function(){
      var videoParent = ele.closest(".video__container--testimonial");
      var videoControls=videoParent.querySelector(".test__content--video video");
      var videoPoster=videoParent.querySelector('.test-image__poster');
      videoControls.controls = false;
      videoControls.pause();
      var playbtn=videoParent.querySelector(".test-play__button");
      playbtn.style.display="block";
      ele.style.display="none";
      videoPoster.style.display="block";
  })
  })

})
  
  